import { ApiResponse, PaginatedResponse } from '@/domain'
import { InvoiceData, InvoiceSummary, InvoiceStatus, UpdateInvoiceItemDescriptionDto, VoucherType } from '../../domain/invoices/invoice'
import { InvoiceDetail } from '../../domain/invoices/invoice-item'
import { backendApi } from '../backendApi'

export interface InvoiceFilters {
  page?: number
  limit?: number
  status?: InvoiceStatus
  voucherType?: string
  search?: string
  fromDate?: string
  toDate?: string
  sortBy?: string
  sortOrder?: 'ASC' | 'DESC'
}

export const invoicesApi = {
  getDataInvoices: (params?: InvoiceFilters) =>
    backendApi.get<ApiResponse<PaginatedResponse<InvoiceDetail> & { summary: InvoiceSummary }>>(`/api/v1/data/invoices`, { params }).then((res) => res.data.data),

  getAgreementInvoicesByPaymentIds: (paymentIds: string[]) =>
    backendApi.post<ApiResponse<InvoiceData[]>>(`/api/v1/data/agreements/invoices`, { paymentIds }).then((res) => res.data.data),

  generateInvoiceDocument: (id: string, voucherType: VoucherType) =>
    backendApi.post<ApiResponse<{ jobId?: string; creditNoteId?: string; invoiceId?: string }>>(`/api/v1/invoices/${id}/generate`, undefined, { params: { voucherType } }).then((res) => res.data.data),

  getDataInvoice: (id: string) =>
    backendApi.get<ApiResponse<InvoiceDetail>>(`/api/v1/data/invoices/${id}`).then((res) => res.data.data),

  updateInvoiceItems: (id: string, items: Array<UpdateInvoiceItemDescriptionDto>) =>
    backendApi.patch<ApiResponse<{ success: boolean }>>(`/api/v1/invoices/${id}/items`, { items }).then((res) => res.data.data),
}
